import { apiCallCenter, apiCallCenterOperador } from '@/plugins/axios'

export default {
  getPausas() {
    return apiCallCenter().get('/agent/pausa')
  },
  getPausaLazy(id){
    return apiCallCenterOperador().get(`/agent/pausa/lazy/${id}`)
  },
  getPausa(id) {
    return apiCallCenter().get(`/agent/pausa/${id}`)
  },
  postPausa(pausa) {
    return apiCallCenter().post('/agent/pausa', pausa)
  },
  putPausa(id, pausa) {
    return apiCallCenter().put(`/agent/pausa/${id}`, pausa)
  },
  deletePausa(id) {
    return apiCallCenter().delete(`/agent/pausa/${id}`)
  },
}
